var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseFilledWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "#0057FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9992,
    cy: 27.9992,
    r: 16.8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0013 4.66797C15.1446 4.66797 4.66797 15.1446 4.66797 28.0013C4.66797 40.858 15.1446 51.3346 28.0013 51.3346C40.858 51.3346 51.3346 40.858 51.3346 28.0013C51.3346 15.1446 40.858 4.66797 28.0013 4.66797ZM35.8413 33.368C36.518 34.0446 36.518 35.1646 35.8413 35.8413C35.4913 36.1913 35.048 36.3546 34.6046 36.3546C34.1613 36.3546 33.718 36.1913 33.368 35.8413L28.0013 30.4746L22.6346 35.8413C22.2846 36.1913 21.8413 36.3546 21.398 36.3546C20.9546 36.3546 20.5113 36.1913 20.1613 35.8413C19.4846 35.1646 19.4846 34.0446 20.1613 33.368L25.528 28.0013L20.1613 22.6346C19.4846 21.958 19.4846 20.838 20.1613 20.1613C20.838 19.4846 21.958 19.4846 22.6346 20.1613L28.0013 25.528L33.368 20.1613C34.0446 19.4846 35.1646 19.4846 35.8413 20.1613C36.518 20.838 36.518 21.958 35.8413 22.6346L30.4746 28.0013L35.8413 33.368Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilledWhite);
export default __webpack_public_path__ + "static/media/CloseFilledWhite.b4e611ab23fbe067f7ee9191bc9df275.svg";
export { ForwardRef as ReactComponent };